import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { VisionButtonComponent } from './vision-button/vision-button.component';

@NgModule({
  exports: [VisionButtonComponent],
  imports: [CommonModule, FontAwesomeModule, QueryParamModule, VisionButtonComponent],
})
export class VisionButtonModule {}
